<!--
  ~ Copyright 2020 Google LLC.
  ~ SPDX-License-Identifier: Apache-2.0
  -->

<a [routerLink]="['/env']">Environment Vis</a>
<br>
<a [routerLink]="['/svg']">Svg Grid</a>
<br>
<a [routerLink]="['/canvas']">Canvas Grid</a>
<br>
<a [routerLink]="['/form']">Form</a>
